import { render } from "./BreakfastList.vue?vue&type=template&id=829aa83e&scoped=true&ts=true"
import script from "./BreakfastList.vue?vue&type=script&lang=ts"
export * from "./BreakfastList.vue?vue&type=script&lang=ts"

import "./BreakfastList.vue?vue&type=style&index=0&id=829aa83e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-829aa83e"]])

export default __exports__